export default "dist/images/rabit2.png"